/**
 * ErrorMessage()
 * @param message = the message that is being displayed
 * @param clear = function to clear the error message off the screen
 */
import React from "react";
import '../../style/ErrorMessage.css';

function ErrorMessage({message, clear}) {
    return (
    <div id= "error-message">
        <p id="error-body">{message}</p> 
        <button id="error-btn" onClick={clear}>Clear</button>
    </div> 
    )
};

export default ErrorMessage;